import React from 'react'
import { Route, Switch, Redirect } from 'react-router-dom'
import { RouteAuthorizer } from '../../Authorizer'

import BusinessModelRoutes from './BusinessModel'
import BotConfigurationRoutes from './BotConfiguration'

// import ChannelsConfigurationRoutes from './ChannelsManagement'
import MessagesConfigurationRoutes from './Messages'
import CredentialsRoutes from './Credentials'
import NotificationsRoutes from './Notifications'
import ChannelsRoutes from './Channels'
import CategoriesRoutes from './Categories'
import ResourcesRoutes from './Resources'
import NautaRoutes from './Nauta'
import SurveyRoutes from './Survey'
import FoldersRoutes from './Folders'

const AuthorizedBusinessModelRoutes = RouteAuthorizer(['operator', 'comunityManager'])(BusinessModelRoutes)
const AuthorizedBotConfigurationRoutes = RouteAuthorizer(['comunityManager'])(BotConfigurationRoutes)
const AuthorizedMessagesConfigurationRoutes = RouteAuthorizer(['operator', 'comunityManager'])(MessagesConfigurationRoutes)
const AuthorizedCredentials = RouteAuthorizer(['comunityManager'])(CredentialsRoutes)
const AuthorizedChannelsConfigurationRoutes = RouteAuthorizer(['operator', 'comunityManager'])(ChannelsRoutes)
const AuthorizedNotificationsConfigurationRoutes = RouteAuthorizer(['comunityManager'])(NotificationsRoutes)
const AuthorizedCategoriesConfigurationRoutes = RouteAuthorizer(['operator', 'comunityManager'])(CategoriesRoutes)
const AuthorizedResourcesConfigurationRoutes = RouteAuthorizer(['operator', 'comunityManager'])(ResourcesRoutes)
const AuthorizedNautaConfigurationRoutes = RouteAuthorizer(['operator', 'comunityManager'])(NautaRoutes)
const AuthorizedSurveyConfigurationRoutes = RouteAuthorizer(['operator', 'comunityManager'])(SurveyRoutes)
const AuthorizedFoldersConfigurationRoutes = RouteAuthorizer(['operator', 'comunityManager'])(FoldersRoutes)

// eslint-disable-next-line react/display-name
export default ({ match }) => (
  <Switch>
    {/* Business Model */}
    <Route path={`${match.path}/business`} component={AuthorizedBusinessModelRoutes} />

    {/* Bot Configurations */}
    <Route path={`${match.path}/bot`} component={AuthorizedBotConfigurationRoutes} />

    {/* Channels */}
    <Route path={`${match.path}/channels`} component={AuthorizedChannelsConfigurationRoutes} />

    {/* Credentials */}
    <Route path={`${match.path}/credentials`} component={AuthorizedCredentials} />

    {/* Console */}
    {/*<Route path={`${match.path}/console`} component={ConsoleFAQ} />*/}

    {/* Messages */}
    <Route path={`${match.path}/messages`} component={AuthorizedMessagesConfigurationRoutes} />

    {/* Notifications */}
    <Route path={`${match.path}/notifications`} component={AuthorizedNotificationsConfigurationRoutes} />

    {/* Categories */}
    <Route path={`${match.path}/categories`} component={AuthorizedCategoriesConfigurationRoutes} />

    {/* Resources */}
    <Route path={`${match.path}/resources`} component={AuthorizedResourcesConfigurationRoutes} />

    {/* Nauta */}
    <Route path={`${match.path}/nauta`} component={AuthorizedNautaConfigurationRoutes} />

    {/* Survey */}
    <Route path={`${match.path}/survey`} component={AuthorizedSurveyConfigurationRoutes} />

    {/* Folders */}
    <Route path={`${match.path}/folders`} component={AuthorizedFoldersConfigurationRoutes} />

    {/* Redirect if exact matched */}
    <Route exact path={match.path} render={() => <Redirect to='/' />} />
  </Switch>
)
